export default  {"src":"/_next/static/image/public/assets/images/sse-airtricity.5fe26cbff2cda0ba0e2d59256dc5fbb7.svg","height":75,"width":177};